import React from "react";

const DateTimeRangePicker = ({
  value,
  onChange,
  minDate,
  openAbove = false,
  error,
  placeholder = "Select date and time",
  showTime = true,
  classNames = "",
}) => {
  return (
    <div className={`relative ${classNames}`}>
      <input
        type={showTime ? "datetime-local" : "date"}
        value={value || ""}
        onChange={onChange}
        min={minDate}
        placeholder={placeholder}
        className={`w-full rounded-lg border ${
          error ? "border-red-500" : "border-gray-600"
        } bg-navy-800 px-3 py-2 text-sm text-white/90 placeholder:text-gray-600 outline-none transition-colors hover:border-gray-500 focus:border-brand-400`}
      />
    </div>
  );
};

export default DateTimeRangePicker;
